// extracted by mini-css-extract-plugin
module.exports = {"beta":"beta-tag_beta__DYSgm","betaTooltip":"beta-tag_betaTooltip__7bn6n","betaPopupDialog":"beta-tag_betaPopupDialog__zJ1JN"};